import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../../global/util/Constant';
import {Headers} from '../../global/util/Headers';
import {StringUtil} from '../../global/util/StringUtil';
import {Revision} from '../components/document/review-document/review-document.component';
import {Contentdeliverymail} from '../model/Contentdeliverymail';
import {Document} from '../model/Document';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private url = Constant.ROOT_API_V1.concat('/documents');
  private url2 = Constant.ROOT_API_V1.concat('/documents2');

  constructor(private http: HttpClient) {
  }

  public upload(formData: FormData): Observable<any> {
    return this.http.post(this.url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public upload2(formData: FormData): Observable<any> {
    return this.http.post(this.url2, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  upload3(url: string, formData: FormData): Observable<any> {
    return this.http.post(url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public uploadTo(url: string, formData: FormData): Observable<any> {
    return this.http.post(url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public reviewOne2One(url: string, formData: FormData): Observable<any> {
    return this.http.post(url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public post(url: string): Observable<any> {
    const formData = new FormData();
    return this.http.post(url, formData);
  }

  public update(url: string, selectedDocuments: any[]): Observable<any> {
    const docIdentifiers = StringUtil.concatIdentifiers(selectedDocuments);
    const formData = new FormData();
    formData.append('docIdentifiers', docIdentifiers);
    return this.http.post(url, formData);
  }

  public getMultipleDocuments(url: string, formData: FormData): Observable<any> {
    return this.http.post(url, formData, {responseType: 'blob'});
  }

  public delete(document: any) {
    const url = this.url.concat('/').concat(String(document.id));
    return this.http.delete(url);
  }

  public revert(url: string): Observable<any> {
    return this.http.post<any>(url, new FormData());
  }

  public finalize(url: string): Observable<any> {
    return this.http.post<any>(url, new FormData());
  }

  public download(url: string): Observable<any> {
    return this.http.get(url, {responseType: 'blob'});
  }

  public postTraceability(url: string): Observable<Response> {
    return this.http.post<any>(url, new FormData());
  }

  public reviewBatch(url: string, revision: Revision): Observable<any> {
    return this.http.post(url, JSON.stringify(revision), Headers.contentType);
  }

  public send2Email(url: string, contentdeliverymail: Contentdeliverymail): Observable<any> {
    return this.http.post(url, JSON.stringify(contentdeliverymail), Headers.contentType);
  }

  public signElectronically(url: string, documents: Document[]): Observable<any> {
    const docIdentifiers = StringUtil.concatIdentifiers(documents);
    const formData = new FormData();
    formData.append('docIdentifiers', docIdentifiers);
    return this.http.post(url, formData);
  }

  /**
   * Envia al API verificación de IOFs o DEMOS NOTCER
   * @param url
   * @param documents
   */
  public verifyUserBalanceOrDemoNotcer(url: string, documents: Document[]): Observable<any> {
    const docIdentifiers = StringUtil.concatIdentifiers(documents);
    const formData = new FormData();
    formData.append('docIdentifiers', docIdentifiers);
    return this.http.post(url, formData);
  }

  public validateAssigner(url: string): Observable<Response> {
    return this.http.post<any>(url, new FormData());
  }

  public cancel(url: string, formData: FormData): Observable<any> {
    return this.http.put<any>(url, formData);
  }

  public permanentlyDelete(documents: Document[]) {
    const url = this.url.concat('/').concat('permanently/delete');
    const documentIds = StringUtil.concatIdentifiers(documents);
    const formData = new FormData();
    formData.append('documentIds', documentIds);
    return this.http.put(url, formData);
  }

  deleteBatch(identifiers: any): Observable<any> {
    const url = this.url.concat('/delete-batch/').concat(identifiers);
    return this.http.delete(url);
  }
}
